import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "./components/Header";
import { useApp } from "./Context/AppContext";

const UserLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const { user, setting } = useApp();

  useEffect(() => {
    if (setting?.web_app_shut_down === true) {
      navigate("/shut-down");
    }
  }, [setting, user, pathname]);

  if (setting) {
    if (setting?.web_app_shut_down !== true) {
      return (
        <div>
          <Header />
          <Outlet />
        </div>
      );
    }
  }
  <Navigate to="/shut-down" />;
};

export default UserLayout;
